import { DocumentSeriesResetPeriodList } from '../../config/documentSeries';
import documentSeriesService from '../../service/documentSeries.service';
import { dataGridPremiumColumns } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';

const DocumentSeriesList = ({ data, refetch, onSelect, viewField, rowSelection }) => {
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;
  const columns = dataGridPremiumColumns([
    { field: 'id', headerName: '#', type: 'number', width: 80 },
    { field: 'name', headerName: 'Megnevezés', type: 'string', minWidth: 220, flex: 1 },
    { field: 'format', headerName: 'Formátum', type: 'string', minWidth: 180 },
    { field: 'nextNumber', headerName: 'Következő sorszám', type: 'number', minWidth: 150 },
    {
      field: 'resetPeriod',
      headerName: 'Újraindítás',
      type: 'singleSelect',
      minWidth: 130,
      valueOptions: DocumentSeriesResetPeriodList,
    },
    { field: 'numberingYear', headerName: 'Számozási év', type: 'number', minWidth: 130 },
    { field: 'active', headerName: 'Aktív', type: 'boolean', minWidth: 90 },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.DocumentSeries}
      datagridInitialState={{
        filter: { filterModel: { items: [], logicOperator: 'and' } },
        sorting: { sortModel: [{ field: 'name', sort: 'asc' }] },
        pagination: { paginationModel: { pageSize: 25, page: 0 } },
        density: 'compact',
      }}
      dataLoader={(gridState) => documentSeriesService.getItems(gridState).then(data.setRows)}
      rows={data.rows.rows}
      rowCount={data.rows.rowCount}
      columns={columns}
      refetch={refetch}
      onRowClick={(rowData) => {
        if (viewField) onSelect(rowData.row.id);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={setRowSelectionModel}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};

export default DocumentSeriesList;
